export const mostEngaged = {
  title: "Most Engaged",
  headers: ["names", "score", "company"],
  data: [
    {
      name: "Brooklyn Simmons",
      score: 42,
      type: "Abstergo Ltd",
      new: true
    },
    {
      name: "Cameron Williamson",
      score: 49,
      type: "Acme Co.",
      new: true
    },
    {
      name: "Jenny Wilson",
      score: 78,
      type: "Barone LLC."
    },
    {
      name: "Marvin McKinney",
      score: 14,
      type: "Biffco Enterprises Ltd."
    }
  ]
};

export const projectInfluencer = {
  title: "Project Influencers",
  headers: ["names", "score", "company"],
  data: [
    {
      name: "Brooklyn Simmons",
      score: 42,
      type: "Abstergo Ltd",
      new: true
    },
    {
      name: "Cameron Williamson",
      score: 49,
      type: "Acme Co.",
      new: true
    },
    {
      name: "Jenny Wilson",
      score: 78,
      type: "Barone LLC."
    },
    {
      name: "Marvin McKinney",
      score: 14,
      type: "Biffco Enterprises Ltd."
    }
  ]
};


export const newlyAdded = {
  title: "Newly Added",
  headers: ["names", "score", "company"],
  data: [
    {
      name: "Brooklyn Simmons",
      score: 42,
      type: "Abstergo Ltd",
      new: true
    },
    {
      name: "Cameron Williamson",
      score: 49,
      type: "Acme Co.",
      new: true
    },
    {
      name: "Jenny Wilson",
      score: 78,
      type: "Barone LLC."
    },
    {
      name: "Marvin McKinney",
      score: 14,
      type: "Biffco Enterprises Ltd."
    }
  ]
};
